import React from "react";
import "./app.css";
import { getImage } from "../../../../../utils/getImages";
import { colors } from "@mui/material";

const LittleDremersPreview = ({ cardData, activetab }) => {
  console.log(cardData)
  const getTitle = () => {
    switch (activetab) {
      case "english":
        return cardData?.title;
      case "simplified_chinese":
        return cardData?.simplified_chinese_title;
      case "arabic":
        return cardData?.traditional_chinese_title;
      case "bahasa":
        return cardData?.bahasa_title;
      default:
        return cardData?.traditional_chinese_title;
    }
  };
   const getBannerImage = (data) => {
        switch (activetab) {
            case "simplified_chinese":
                return data?.image3;
            case "treditonal_chinese":
                return data?.image4;
            case "english":
            default:
                return data?.image2;
        }
    };

  const getSubtitle = () => {
    switch (activetab) {
      case "english":
        return cardData?.subtitle;
      case "simplified_chinese":
        return cardData?.simplified_chinese_subtitle;
      case "arabic":
        return cardData?.traditional_chinese_subtitle;
      case "bahasa":
        return cardData?.bahasa_subtitle;
      default:
        return cardData?.traditional_chinese_subtitle;
    }
  };

  return (
    <div>
      <div className="two-section-container">
        {/* LEFT SECTION */}
        <div
          className="left-section"
          style={{
            direction: activetab === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div className="left-content">
            <h1 className="title">{getTitle()}</h1>
            <h1 className="subtitle mt-2">{getSubtitle()}</h1>
            <p className=" mt-2" style={{ direction: activetab === "arabic" && "rtl" }}
              dangerouslySetInnerHTML={{
                __html:
                  activetab === "english"
                    ? cardData?.description
                    : activetab === "simplified_chinese"
                      ? cardData?.simplified_chinese_description
                      : activetab === "arabic"
                        ? cardData?.traditional_chinese_description
                        : activetab === "bahasa"
                        ? cardData?.bahasa_description
                        : cardData?.traditional_chinese_description,
              }}></p>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="right-section">
          <img
            src={getImage(cardData?.image)}
            alt="preview-right"
            className="right-image"
          />
        </div>
      </div>
      <div style={{
        // marginTop: "50px",
        // backgroundImage: `url(${getImage(item?.image2)})`,
        // backgroundSize: "cover",
        // backgroundPosition: "center",
        // backgroundRepeat: "no-repeat",
        // width: "100%",
        // height: "100%",
        margin: "50px",
        borderRadius: "20px",
        background: "linear-gradient(148deg, rgba(12,25,90,1) 0%, rgba(42,57,137,1) 50%, rgba(240,64,120,1) 100%)"
      }}>
        <div
          className="col-12 text-center mb-5"
          style={{
            alignItems: "center",
          }}
        >

          <ul
            className="page-tab scroll-tab"
            style={{
              display: "flex",
              gap: "10px",

              listStyleType: "none",
              padding: 0,
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              margin: 0,
              width: "100%",
            }}
          >
            {cardData?.dataArray?.map((item, index) => (
              <li data-scroll-tab-seq={index + 1 + ""} className="" style={{
                display: "flex",
                gap: "10px",
                listStyleType: "none",
                padding: 0,
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                margin: "10px",
                width: "100%",
              }}>
                <img
                  src={getImage(cardData?.dataArray?.[0].image)}
                  alt="icon"
                  style={{ width: "60px", height: "35px" }}
                />
                {activetab === "english"
                  ? item?.ship_title
                  : activetab === "simplified_chinese"
                    ? item?.simplified_chinese_ship_title
                    : activetab === "arabic"
                      ? item?.traditional_chinese_ship_title
                      : activetab === "bahasa"
                      ? item?.bahasa_ship_title
                      : item?.traditional_chinese_ship_title}
              </li>
            ))}

          </ul>
          <div>
            <img
              src={getImage(getBannerImage(cardData?.dataArray?.[0]))}
              alt="icon"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            // alignItems: "center",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: "10px",
          }}
        >
          <div className="row" style={{ width: "100%" }}>
            {cardData?.dataArray?.map((item) => (
              <div style={{ width: "100%" }}>
                <div className="col-12 ml-3 scroll-content-1">
                  <h2
                    className="mb-5 title-grey"
                    style={{ direction: activetab === "arabic" && "rtl", color: "white" }}
                  >
                    {activetab === "english"
                      ? item?.heading
                      : activetab === "simplified_chinese"
                        ? item?.simplified_chinese_heading
                        : activetab === "arabic"
                          ? item?.traditional_chinese_heading
                          : activetab === "bahasa"
                          ? item?.bahasa_heading
                          : item?.traditional_chinese_heading}
                  </h2>
                </div>

                <div className="row p-3">
                  {item?.dataArray?.map((item1, index) => (
                    <div key={index} className="col-md-4 mt-5">
                      <img src={getImage(item1?.image)} alt="" className="card-imageld" />
                      <div className="card-priceld">
                        {activetab === "english"
                          ? item1?.price
                          : activetab === "simplified_chinese"
                            ? item1?.simplified_chinese_price
                            : activetab === "arabic"
                              ? item1?.traditional_chinese_price
                              : activetab === "bahasa"
                              ? item1?.bahasa_price
                              : item1?.traditional_chinese_price}
                      </div>

                      <h3 className="card-titleld">
                        {activetab === "english"
                          ? item1?.title
                          : activetab === "simplified_chinese"
                            ? item1?.simplified_chinese_title
                            : activetab === "arabic"
                              ? item1?.traditional_chinese_title
                              : activetab === "bahasa"
                              ? item1?.bahasa_title
                              : item1?.traditional_chinese_title}

                        {/* <span style={{ marginLeft: "120px" }}>{activetab === "english"
                          ? item1?.price
                          : activetab === "simplified_chinese"
                            ? item1?.simplified_chinese_price
                            : activetab === "arabic"
                              ? item1?.traditional_chinese_price
                              : activetab === "bahasa"
                              ? item1?.bahasa_price
                              : item1?.traditional_chinese_price}</span> */}
                      </h3>
                      <br /><br />
                      <p className="description" style={{ direction: activetab === "arabic" && "rtl", height: '170px' }}
                        dangerouslySetInnerHTML={{
                          __html:
                            activetab === "english"
                              ? item1?.description
                              : activetab === "simplified_chinese"
                                ? item1?.simplified_chinese_description
                                : activetab === "arabic"
                                  ? item1?.traditional_chinese_description
                                  : activetab === "bahasa"
                                  ? item1?.bahasa_description
                                  : item1?.traditional_chinese_description,
                        }}></p>
                      {(
                        activetab === "english"
                          ? item1?.tag
                          : activetab === "simplified_chinese"
                            ? item1?.simplified_chinese_tag
                            : activetab === "arabic"
                              ? item1?.traditional_chinese_tag
                              : activetab === "bahasa"
                              ? item1?.bahasa_tag
                              : item1?.traditional_chinese_tag
                      ) && (
                          <div className="tag">
                            <span>
                              {activetab === "english"
                                ? item1?.tag
                                : activetab === "simplified_chinese"
                                  ? item1?.simplified_chinese_tag
                                  : activetab === "arabic"
                                    ? item1?.traditional_chinese_tag
                                    : activetab === "bahasa"
                                    ? item1?.bahasa_tag
                                    : item1?.traditional_chinese_tag}
                            </span>
                          </div>
                        )}

                    </div>
                  ))}
                </div>
                <p className="description m-3" style={{ color: "white", direction: activetab === "arabic" && "rtl" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      activetab === "english"
                        ? cardData?.dataArray[0].note
                        : activetab === "simplified_chinese"
                          ? cardData?.dataArray[0].simplified_chinese_note
                          : activetab === "arabic"
                            ? cardData?.dataArray[0].traditional_chinese_note
                            : activetab === "bahasa"
                            ? cardData?.dataArray[0].bahasa_note
                            : cardData?.dataArray[0].traditional_chinese_note,
                  }}></p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  )
};

export default LittleDremersPreview;
